import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { useContext, useEffect, useState } from "react";
import CheckCircleIcon from "@icons/CheckCircleIcon";
import EmptyCircleIcon from "@icons/EmptyCircleIcon";
import { IconButton, Skeleton, Typography } from "@mui/material";
import ChevronLeft from "@icons/ChevronLeft";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import { getApiResponse } from "@utils/service";
import { ErrorState, message } from "@src/constants";
import Colors from "@constants/Colors";
import { StyledBox, StyledRootBox } from "./style";

interface EvenTypeSelectorProps {
  handleClose: (value: string) => void;
  currentEvent: string;
}

const EventTypeSelector = ({
  handleClose,
  currentEvent,
}: EvenTypeSelectorProps) => {
  const [checked, setChecked] = useState<string>(currentEvent);
  const [loading, setloading] = useState(true);
  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);
  const [typeOptions, setTypeoptions] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      setloading(true);
      const result = await getApiResponse("event/types");
      setloading(false);
      if (result?.data) {
        setTypeoptions(result?.data);
      } else {
        showErrorToastSetState({
          errorMessage: result?.error || "",
          errorTitle: message.ERROR_MESSAGE_EventTypes,
          open: true,
        });
      }
    })();
  }, []);

  const handleToggle = (value: string) => () => {
    setChecked(value);
  };

  const getValue = (labelId: string, value: string) => {
    if (loading) return <Skeleton />;
    if (!value) return <ErrorState />;
    return <ListItemText id={labelId} primary={value} />;
  };

  return (
    <>
      <StyledBox>
        <IconButton
          onClick={() => {
            handleClose(checked);
          }}
        >
          <ChevronLeft />
        </IconButton>
        <Typography>Event Type</Typography>
      </StyledBox>
      <StyledRootBox>
        <List dense sx={{ bgcolor: Colors.white }}>
          {typeOptions?.map((value) => {
            const labelId = `checkbox-list-secondary-label-${value}`;
            return (
              <ListItem
                key={value}
                onClick={handleToggle(value)}
                secondaryAction={
                  <Checkbox
                    checkedIcon={<EmptyCircleIcon />}
                    icon={<CheckCircleIcon />}
                    edge="end"
                    onChange={handleToggle(value)}
                    checked={checked === value}
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                }
                disablePadding
              >
                <ListItemButton>{getValue(labelId, value)}</ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </StyledRootBox>
    </>
  );
};

export default EventTypeSelector;
